  function openTab(e, tabNumber) {
  var i;
  var x = document.getElementsByClassName("tab__inside");
  
  /*Add or Remove Active class to buttons*/
  $('button.category').removeClass('category-active');
  $(e).addClass('category-active');

  /*Add active or remove class to tab contents*/
  for (i = 0; i < x.length; i++) {
    x[i].classList.remove("tab__inside-active");
  }
  document.getElementById(tabNumber).classList.add("tab__inside-active");

}